import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js';
import { fmtDec, MetricCard, BarList, GC, TC } from '../utils';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const REP_COLORS = { peter:'#3ea4b1', mitch:'#7F77DD', jared:'#1D9E75', sarah:'#D4537E', dan:'#EF9F27', barry:'#888780', justin:'#5DCAA5', kelsey:'#F0997B' };

export default function MyDashboard({ data, user }) {
  const { owners = [], commissionSummary = [], commissionRates = [], payouts = [], categories = [], itemsRev = [] } = data;

  const myOwner = owners.find(o => o.name.toLowerCase().includes(user.name.split(' ')[0].toLowerCase()));
  const myRevenue = myOwner?.total || 0;
  const summary = commissionSummary.find(s => s.name.toLowerCase().includes(user.name.split(' ')[0].toLowerCase()));
  const rateRow = commissionRates.find(r => r.name.toLowerCase().includes(user.name.split(' ')[0].toLowerCase()));
  const myPayouts = payouts.filter(p => p.owner.toLowerCase().includes(user.name.split(' ')[0].toLowerCase()));
  const totalPaid = myPayouts.reduce((s, p) => s + p.amount, 0);
  const color = REP_COLORS[user.repId] || 'var(--brand)';

  const chartData = {
    labels: ['Revenue', 'Commission earned', 'Paid out', 'Balance due'],
    datasets: [{
      data: [myRevenue, summary?.commission || 0, totalPaid, summary?.due || 0],
      backgroundColor: ['#3ea4b1', '#1D9E75', '#7F77DD', summary?.due > 0 ? '#E24B4A' : '#e5e7eb'],
      borderRadius: 6, borderSkipped: false,
    }],
  };
  const chartOpts = {
    responsive: true, maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => '$' + ctx.parsed.y.toLocaleString('en-US', { minimumFractionDigits: 2 }) } } },
    scales: { x: { grid: { display: false }, ticks: { color: TC, font: { size: 12 } } }, y: { grid: { color: GC }, ticks: { color: TC, font: { size: 11 }, callback: v => '$' + (v >= 1000 ? (v / 1000).toFixed(0) + 'k' : v.toFixed(0)) } } },
  };

  const topCats = [...categories].filter(c => c.total > 0).sort((a, b) => b.total - a.total).slice(0, 5);

  return (
    <div>
      <div className="rep-welcome">
        <h2>Welcome back, {user.name.split(' ')[0]}!</h2>
        <p>Here's your performance overview for 2026.</p>
      </div>

      <div className="metrics">
        <MetricCard label="Your revenue" value={fmtDec(myRevenue)} sub="2026 YTD" />
        <MetricCard label="Commission earned" value={summary ? fmtDec(summary.commission) : '—'} sub={rateRow ? rateRow.rate + '% ' + rateRow.type : 'No commission plan'} />
        <MetricCard label="Total paid out" value={totalPaid > 0 ? fmtDec(totalPaid) : '—'} sub={myPayouts.length + ' payment' + (myPayouts.length !== 1 ? 's' : '') + ' received'} />
        <MetricCard label="Balance due" value={summary?.due > 0 ? fmtDec(summary.due) : '—'} sub={summary?.due > 0 ? 'Pending payout' : 'Fully paid'} valueStyle={summary?.due > 0 ? { color: 'var(--red)' } : {}} />
      </div>

      <div className="charts-grid single">
        <div className="chart-card">
          <div className="chart-card-title">Your numbers at a glance</div>
          <div className="chart-card-sub">Revenue, commission earned, paid out, and balance due</div>
          <div className="chart-wrap" style={{ height: 200 }}><Bar data={chartData} options={chartOpts} /></div>
        </div>
      </div>

      <div className="two-col">
        <div className="chart-card">
          <div className="chart-card-title">Top 5 categories</div>
          <div className="chart-card-sub">Based on JG Graphics overall sales</div>
          <BarList items={topCats.map(c => [c.name, c.total])} maxVal={topCats[0]?.total || 1} isMoney />
        </div>
        <div className="chart-card">
          <div className="chart-card-title">Top 10 items by revenue</div>
          <div className="chart-card-sub">Based on JG Graphics overall sales</div>
          <BarList items={itemsRev.slice(0, 10)} maxVal={itemsRev[0]?.[1] || 1} isMoney />
        </div>
      </div>
    </div>
  );
}
